import PositionView from 'src/sections/overview/position/view/position-view';

export default function Position() {
  return <PositionView />;
}
